exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AA5I{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "AA5I",
	"root": "AA5I"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/Header/Header.css
// module id = 171
// module chunks = 0